import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { FilterValue } from '../../../../app/interfaces/base/filter-value';
import { ApiService } from '../../../../app/services/base/api.service';

@Component({
  selector: 'fury-table-filter-date-time',
  templateUrl: './table-filter-date-time.component.html',
  styleUrls: ['./table-filter-date-time.component.scss'],
})
export class TableFilterDateTimeComponent implements OnInit, OnDestroy {

  public isFiltered: boolean = false;

  public date: FormControl<Date | null> = null;

  @Input() name: string = null;

  @Input() customFiltering: boolean = false;
  @Output() clearFilter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private api: ApiService,
              private cd: ChangeDetectorRef) {
  }

  @HostListener('keydown.space', ['$event'])
  @HostListener('click', ['$event']) onClick(e: Event): void {
    e.stopPropagation();
  }

  ngOnInit(): void {
    this.date.valueChanges.pipe(
      takeUntil(this.destroy$),
      debounceTime(200),
    ).subscribe((data): void => {
      if (data) {
        this.filterChanged();
      }
    });

    this.api.preSetFilters.pipe(
      take(1),
      takeUntil(this.destroy$)
    ).subscribe((filters: FilterValue[]): void => {
      filters.forEach((filter: FilterValue): void => {
        if (this.name === filter.name) {
          const date: string[] = (<string>filter.value).split('!');
          this.date.setValue(new Date(date[0]), {emitEvent: false});
          this.cd.detectChanges();

          this.isFiltered = !!this.date.value;
        }
      });
    });

    this.api.filterCleared.pipe(takeUntil(this.destroy$)).subscribe((): void => this.clearFilterButton());
    this.api.clearAllFilters.pipe(takeUntil(this.destroy$)).subscribe((): void => this.clearFilterButton(false));
  }

  filterChanged(): void {
    this.isFiltered = !!this.date.value;

    if (this.customFiltering) {
      this.filterChange.emit(moment(this.date.value).toISOString());
    } else {
      this.api.setFilter(this.name, moment(this.date.value).toISOString());
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  clearFilterButton(emitEvent: boolean = true): void {
    this.date.setValue(null);

    this.isFiltered = false;

    if (emitEvent) {
      if (this.customFiltering) {
        this.clearFilter.next();
      } else {
        this.api.clearFilter(this.name);
      }
    }
  }
}
